export default (user) => {
    return localStorage.setItem('app_user', user)
}